import { createFeatureSelector, createSelector } from "@ngrx/store";
import { VoucherState } from "./voucher";

const voucherState = createFeatureSelector<VoucherState>("voucher");

export const GetVoucherEnabled = createSelector(
  voucherState,
  (state) => state.enabled,
);

export const GetVoucherAvailabilityLoaded = createSelector(
  voucherState,
  (state) => state.availabilityLoaded,
);

export const GetVoucherPharmacies = createSelector(
  voucherState,
  (state) => state.pharmacies,
);

export const GetSelectedVoucherPharmacy = createSelector(
  voucherState,
  (state) => state.selectedPharmacy,
);

/**
 * Die Apotheke, auf die gebucht wird — aus der Auswahl aufgelöst.
 * ⚠ Bei genau einer Apotheke setzt der Reducer die Auswahl selbst; der Fallback
 * fängt nur den Fall ab, dass das noch nicht passiert ist.
 */
export const GetActiveVoucherPharmacy = createSelector(voucherState, (state) =>
  state.pharmacies.length === 1
    ? state.pharmacies[0]
    : (state.pharmacies.find(
        (pharmacy) => pharmacy.id === state.selectedPharmacy,
      ) ?? null),
);

/** true, wenn der Apotheker vor dem Einlösen eine Apotheke wählen muss. */
export const GetNeedsPharmacySelection = createSelector(
  voucherState,
  (state) => state.pharmacies.length > 1 && !state.selectedPharmacy,
);

export const GetVoucher = createSelector(
  voucherState,
  (state) => state.voucher,
);

export const GetVoucherRedemption = createSelector(
  voucherState,
  (state) => state.redemption,
);

export const GetVoucherHistory = createSelector(
  voucherState,
  (state) => state.history,
);

export const GetVoucherCheckStatus = createSelector(
  voucherState,
  (state) => state.checkStatus,
);

export const GetVoucherReservation = createSelector(
  voucherState,
  (state) => state.reservation,
);

export const GetVoucherReserveStatus = createSelector(
  voucherState,
  (state) => state.reserveStatus,
);

export const GetVoucherConfirmStatus = createSelector(
  voucherState,
  (state) => state.confirmStatus,
);

export const GetVoucherCancelStatus = createSelector(
  voucherState,
  (state) => state.cancelStatus,
);

export const GetVoucherError = createSelector(
  voucherState,
  (state) => state.error,
);

/**
 * Verfügbares Guthaben. `value_current` ist während einer Reservierung bereits
 * um den reservierten Betrag reduziert — der reservierte Teil wird auf dem
 * Bestätigen-Screen separat ausgewiesen.
 */
export const GetVoucherBalance = createSelector(
  voucherState,
  (state) => state.voucher?.value_current ?? null,
);
